import { useState } from 'react';

import { Card, Text } from '@ngsos/portal-ui';

import { incidentListRoute } from '@/features/shared/routes';
import { LanguageSelector, NgPageHeader } from '@/ui';
import { createDemoIncidents } from './demoApi';

const PAGE_TITLE = 'Demo incidents';

export function DemoHelperPage() {
  const [isCreating, setIsCreating] = useState(false);

  const createDemoIncidentsForLanguage = async (selectedLanguage: string) => {
    try {
      setIsCreating(true);
      await createDemoIncidents(selectedLanguage);

      window.location.href = incidentListRoute();
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <div className="content p-3">
      <NgPageHeader title={PAGE_TITLE} />
      <h1 className="mb-4">{PAGE_TITLE}</h1>

      <div className="d-flex flex-column gap-4">
        <div>
          {isCreating ? (
            <Card>
              <div className="d-flex justify-content-between align-items-center gap-3">
                <Text variant="title" role="heading" aria-level={3}>
                  Creating demo incidents
                </Text>
                <div className="spinner-border spinner-border-sm opacity-50" role="status">
                  <span className="visually-hidden"> Creating...</span>
                </div>
              </div>
            </Card>
          ) : (
            <LanguageSelector
              title="Create demo incidents in"
              placeholder="Select language"
              onSelect={(culture) => void createDemoIncidentsForLanguage(culture)}
            />
          )}
        </div>
      </div>
    </div>
  );
}
